module Meevo.Plugins.CompensationSettings {
    "use strict";

    /**
    * Main Section of ClockInOutRules Section
    */
    export class ClockInOutRulesSection extends Meevo.Components.CommonClasses.SettingsSectionBase {

        public minutes: Array<number> = _.range(0, 20, 5).concat([30, 45, 60]);

        updateSystemAccess(): any {
            this.model = <Meevo.Model.CompensationSettings>this.model;
            if (!this.model.restrictEarlyClockIn) {
                this.model.allowSystemAccess = true
                this.model.earlyClockInMinutes = 0;
            }
        }

    }
}